(() => {
  if (window.hpSectionSchedule || window.Shopify?.designMode) return;
  let timeout;

  const update = () => {
    window.clearTimeout(timeout);
    const now = Date.now();
    let nextBoundary = Infinity;
    let changed = false;

    document.querySelectorAll('style[data-hp-section-schedule]').forEach((style) => {
      const start = style.dataset.start ? Number(style.dataset.start) * 1000 : null;
      const end = style.dataset.end ? Number(style.dataset.end) * 1000 : null;
      const section = document.getElementById(`shopify-section-${style.dataset.sectionId}`);
      if (!section || (start !== null && !Number.isFinite(start)) || (end !== null && !Number.isFinite(end))) return;
      if (start !== null && end !== null && end <= start) return;
      const hidden = (start !== null && now < start) || (end !== null && now >= end);
      const rule = hidden ? `#${CSS.escape(section.id)} { display: none !important; }` : '';
      if (style.textContent.trim() !== rule) {
        style.textContent = rule;
        changed = true;
        if (hidden) section.querySelectorAll('video').forEach((video) => video.pause());
      }
      [start, end].forEach((boundary) => {
        if (boundary !== null && boundary > now) nextBoundary = Math.min(nextBoundary, boundary);
      });
    });

    if (changed) window.dispatchEvent(new Event('resize'));
    if (Number.isFinite(nextBoundary)) timeout = window.setTimeout(update, Math.min(nextBoundary - now, 60000));
  };

  window.hpSectionSchedule = { update };
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', () => window.setTimeout(update, 0));
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();
